import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../component/Card';
import { useTranslation } from 'react-i18next';

const UnitSection = () => {
    const { t, i18n } = useTranslation();
    const [dataUnit, setDataUnit] = useState([]);
    const [loading, setLoading] = useState(true);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_PRICE = 'api/rentcar/unit';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`${BASE_URL}${PATH_PRICE}`);
                setDataUnit(data || []);
            } catch (err) {
                console.error('Error fetching price data:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <section id="unit" className="py-16 bg-white">
            <div className="max-w-5xl mx-auto px-4">
                <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
                    {t('available_units')}
                </h2>

                {loading ? (
                    <div className="text-center py-12">
                        <div className="w-10 h-10 mx-auto border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
                        <p className="text-sm mt-3 text-gray-500">{t('loading_units')}</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {dataUnit.map((unit, idx) => (
                            <Card key={idx} className="shadow hover:shadow-lg transition">
                                <img src={`${BASE_URL}/upload/rentcar/${unit.foto}`} alt={unit.nama_unit} className="w-full h-48 object-cover" />
                                <CardContent className="p-4">
                                    <h4 className="text-xl font-semibold mb-1">{unit.nama_unit}</h4>
                                    <p>{unit.kapasitas} Orang | {unit.transmisi}</p>
                                    {/* | {unit.ac ? "AC" : "Tanpa AC"} */}
                                    {/* <div className="mt-4 flex justify-between">
                                        <Button size="sm">Detail</Button>
                                    </div> */}
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default UnitSection;